const id_sales_priceStock = {
    "": "daftar harga & stok",
}

export default id_sales_priceStock;